import React from 'react'

export default function SampleNextArrow(props) {
  const { style, onClick } = props
  return (
    <div
      type="button"
      // className="slick-next"
      style={{ ...style, display: 'block' }}
      onClick={onClick}>
      <div className="slick-prev arrow-left"></div>
    </div>
  )
}
